export default "__VITE_ASSET__XW53hhZC__"